export default __webpack_public_path__ + "media/images/react_icons/property/ceiling_fan-8b6cfb2d5d1b7d0d7620045426a6c97b.svg";